import InsightsSection from '@/views/insights/InsightsSection.vue';
import InsightsDashboard from '@/views/insights/tabs/InsightsDashboard.vue';
import InsightsConfiguration from '@/views/insights/tabs/InsightsConfiguration.vue';

export default [
  {
    path: '/insights',
    component: InsightsSection,
    meta: {
      breadcrumb: {
        linkName: 'insights.index',
        linkText: 'Insights',
      },
    },
    children: [
      {
        path: '',
        component: InsightsDashboard,
        name: 'insights.index',
      },
      {
        path: 'config',
        component: InsightsConfiguration,
        name: 'insights.config',
      },
    ],
  },
];
